module.exports = __webpack_public_path__ + "img/ball_5.e596803c.svg";